import { type DefaultAvatarState, getDefaultAvatarUrl } from './defaultAvatars';
import { usePlayerAvatar } from './usePlayerAvatar';
import { usePlayerCustomAvatar } from './usePlayerCustomAvatar';

/**
 * Resolve the avatar image URL to render for the local player. A custom
 * (uploaded) avatar wins when present — the uploader sees their own image
 * immediately, even while it's PENDING review (per the moderation policy) —
 * otherwise the chosen commissioned built-in face for the requested state.
 *
 * @returns the URL string, or null when neither resolves (e.g. a trimmed dev
 *   build with no asset manifest) so callers can render their own fallback.
 */
export function usePlayerAvatarUrl(state: DefaultAvatarState = 'idle'): string | null {
  const [builtinId] = usePlayerAvatar();
  const [custom] = usePlayerCustomAvatar();
  if (custom?.url) return custom.url;
  return getDefaultAvatarUrl(builtinId, state);
}
